"use client";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";

interface LeaderboardV2SkeletonProps {
  className?: string;
}

const SKELETON_ITEMS_COUNT = 5;

export const LeaderboardV2Skeleton = forwardRef<
  HTMLDivElement,
  LeaderboardV2SkeletonProps
>(({ className }, ref) => {
  return (
    <Card
      ref={ref}
      className={cn("w-full bg-background/20 backdrop-blur-xl", className)}
    >
      <CardContent className="p-6 space-y-5">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-muted/20 rounded w-32" />
          <div className="h-px bg-muted/20" />
          <div className="space-y-2">
            {Array.from({ length: SKELETON_ITEMS_COUNT }, (_, i) => (
              <div
                key={`skeleton-item-${i + 1}`}
                className="h-12 bg-muted/20 rounded"
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
});

LeaderboardV2Skeleton.displayName = "LeaderboardV2Skeleton";
